import { render } from "./bolide_loader.html?vue&type=template&id=9d89b322&external"
import script from "./bolide_loader.js?vue&type=script&lang=js&external"
export * from "./bolide_loader.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__